<!--
  - Copyright (c) 2022.
  -
  - Unless required by applicable law or agreed to in writing, software
  - distributed under the License is distributed on an "AS IS" BASIS,
  - WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  - See the License for the specific language governing permissions and
  - limitations under the License.
  -
  -->

<template>
    <div>
        <van-nav-bar
            title="我的订单"
            left-arrow
            @click-left="$router.go(-1)"
        />

        <MyProductOrder v-if="active === 0"/>
        <MyGoodsOrder v-if="active === 1"/>

        <van-tabbar v-model="active" active-color="var(--color)" inactive-color="#6B6B6B">
            <van-tabbar-item icon="like-o">体检订单</van-tabbar-item>
            <van-tabbar-item icon="thumb-circle-o">好医推荐</van-tabbar-item>
        </van-tabbar>

    </div>
</template>

<script>
import moment from "moment";
import http, {BASE_CDN_URL, BASE_URL} from "@/utils/http";
import qs from "qs";
import MyProductOrder from "@/views/MyProductOrder";
import MyGoodsOrder from "@/views/MyGoodsOrder";

export default {
    name: "MyOrder",
    components: {MyProductOrder, MyGoodsOrder},
    data() {
        return {
            active: 0,
        };
    },
    created() {
    },
    methods: {
    }
}
</script>

<style scoped>

</style>